import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a88f6c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "teammate-card_block" }
const _hoisted_2 = {
  key: 0,
  class: "teammate-card_user-content"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "teammate-card_user-info" }
const _hoisted_6 = { key: 0 }

import { computed, inject, onMounted, onUnmounted, PropType, Ref, ref, watch } from 'vue';
import {
  TirPmDraggableSorting,
  TirPmIconView,
  TirPmNotificationGroup,
  TirPmPagination,
  TirPmSystemMessage,
} from 'tir-components';
import { TirPmNotificationEventBus, TirPmNotificationModel } from 'tir-components';
import {
  AddOrRemoveTaskEventDataModel,
  AddTaskZmkForUserRequest,
  OrderTaskModel,
  TaskFilterModel,
  TaskSortingModel,
  TeammateModel,
} from '../../models';
import { TasksOrderPagesAdapterService, UpdateTaskAdapterService } from '../../adapter-service';
import { TasksKanbanFilterModel } from '@/components/tasks-kanban/models';
import { ProjectModel } from '@/models';
import { useRouter } from 'vue-router';
import { TaskViewElementEnum } from '@/components/tasks-kanban/enums';
import ProjectTaskLi from '../../components/project-tasks/project-task-li.vue';
import { TaskColumnModel } from '@/pages/employee-tasks-page/models';
import { TaskHeader } from '../../components';
import PageResponseModel from '@/pages/monitorings/models/PageResponseModel';
import PageResponse from '../../models/PageResponseModel';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import { DragModel } from '@/components/tir-pm-kanban';
import TaskOrderLi from '../../components/tasks-order-list/task-order-li.vue';

/**Адаптер */

export default /*#__PURE__*/_defineComponent({
  __name: 'teammate-card',
  props: {
  /**разрешить перетаскивание */
  isEnableDrag: { type: Boolean, default: true },
  /**Был ли применен фильтр */
  isApplyFilter: { type: Boolean },
  /**Сокомандник */
  user: { type: Object as PropType<TeammateModel>, required: true },
  /**Открыт ли список */
  isOpened: { type: Boolean },
  /**id юзера из роутера */
  routerUserId: { type: Number },
  /**id проекта из роутера */
  routerProjectId: { type: Number },
  /**id задач */
  tasksIds: { type: Array as PropType<number[]> },
  /**Отображаемые элементы */
  viewElements: {
    type: Array as PropType<Array<TaskViewElementEnum>>,
    required: true,
  },
  /**Фильтр */
  filter: { type: Object as PropType<TasksKanbanFilterModel> },
  tasks: { type: Array as PropType<OrderTaskModel[]> },
  /**Данные страниц */
  pageResponse: { type: Object as PropType<PageResponseModel> },
  /**Кол-во элементов на странице */
  pageStep: { type: Number },
  /** список только моих задач */
  showOnlyMyTasks: { type: Boolean },
},
  emits: ["update:is-opened", "add", "openTaskDrawer", "removeTask", "geTaskOverviewList", "updateListTasksUsers", "changePageStep", "changeCurrentPage", "updateTaskOrder", "updateList", "sortData", "toggleExecutionTask"],
  setup(__props, { emit }) {

const props = __props;

const adapter = new TasksOrderPagesAdapterService();
/**Маршруты */
const router = useRouter();

const updateTaskAdapter = UpdateTaskAdapterService.getInstance();

// #region defineProps
/**Параметры */


// #endregion defineProps

// #region defineEmits
/**События */

/** текущий пользователь */
const userId = computed(() => props.user?.Id || CurrentUser.Id);
const isDragging = ref(true);
watch(
  () => props.isEnableDrag,
  (newValue) => {
    isDragging.value = props.isEnableDrag;
  },
);
// #endregion defineEmits

// #region refs
/**Доступ на редактирование всего списка очередности */
const fullChangeAccessOrder = ref(false);
/**Список задач на выполнение */
const executionTasks = ref<OrderTaskModel[]>([]);
/**Список проектов */
const projects = ref<Array<ProjectModel>>([]);
/**id перетаскиваемой задачи */
const dragTaskId = ref<number | null>(null);
/**Новая позиция перетаскиваемой  */
const newPosition = ref<number | null>(null);

/**Колонки */
const columns: TaskColumnModel[] = [
  new TaskColumnModel({
    Type: TaskViewElementEnum.Project,
    Name: '',
    Width: '1.5rem',
    MinWidth: '1.5rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Namespace,
    Name: '',
    Width: '1.5rem',
    MinWidth: '1.5rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Queue,
    Name: 'Очередь',
    Width: '9.375rem',
    MinWidth: '9.375rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Number,
    Name: '№',
    Width: '5rem',
    MinWidth: '5rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Status,
    Name: 'Статус',
    Width: '8.75rem',
    MinWidth: '8.75rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Name,
    Name: 'Название',
    Width: '50vw',
    MinWidth: '25vw',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Priority,
    Name: 'Приоритет',
    Width: '4rem',
    MinWidth: '4rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Difficulty,
    Name: 'Сложность',
    Width: '3rem',
    MinWidth: '3rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.EstimateTime,
    Name: 't (оценка)',
    Width: '5rem',
    MinWidth: '5rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.WorkTime,
    Name: 't (затрачено)',
    Width: '5rem',
    MinWidth: '5rem',
    Align: 'center',
  }),
];
// #endregion refs

// #region computed
/**Список идентификаторов задач на выполнение */
const executionQueueIds = computed(() => executionTasks.value.map((task) => task.Id));
/**Кол-во страниц */
const pagesCount = computed(() => {
  return props.pageResponse ? Math.ceil(props.pageResponse.Count / props.pageResponse.Size) : 0;
});
/**Инициалы пользователя */
const userInitials = computed(
  () => props.user?.FirstName[0].toUpperCase() + props.user?.LastName[0].toUpperCase(),
);
/**Список задач не в очередности */
const nonQueuedTasks = computed(() => {
  return props.tasks.filter((task) => !task.ZmkType);
});
/**Список задач в очередности */
const queuedTasks = computed(() => {
  return props.tasks.filter((task) => task.ZmkType);
});
/**Задачи для перетаскивания */
const dragTasks = computed(() => {
  return (
    props.tasks
      .filter((t) => t.IsHighlighted)
      .map(
        (task) =>
          new DragModel({
            Data: task,
            AllowDrag: task.ChangeAccess,
            AllowDrop: true,
          }),
      ) || []
  );
});

/**Список задач без очередности */
const tasks = computed(() => {
  return props.tasks.filter((task) => !task.IsHighlighted);
});
/**Найденный список задач */
const searchedExecutionTasks = computed(() => {
  if (!props.filter.Search) return executionTasks.value;
  const search = props.filter.Search?.toLocaleLowerCase() || '';
  return executionTasks.value.filter((task) => {
    return (
      task.Name.toLocaleLowerCase().includes(search) ||
      String(task.Id).toLocaleLowerCase().includes(search)
    );
  });
});
// #endregion computed

// #region Хуки жизненного цикла
onMounted(async () => {
  updateTaskAdapter.OnUpdateTaskEvent.on(onUpdateTask);
  updateTaskAdapter.OnAddOrRemoveEmployeeTask.on(onAddRemovePerformerTask);

  if (props.routerUserId === props.user?.Id || CurrentUser.Id) {
    if (props.isOpened && !projects.value.some((p) => p.Id == props.routerProjectId)) {
      router.replace({ query: {} });
    }
  }
});

onUnmounted(() => {
  updateTaskAdapter.OnUpdateTaskEvent.removeListener(onUpdateTask);
  updateTaskAdapter.OnAddOrRemoveEmployeeTask.removeListener(onAddRemovePerformerTask);
});
// #endregion Хуки жизненного цикла

// #region watch
watch(
  () => executionQueueIds.value,
  async (currentValue, prevValue) => {
    if (!currentValue) return;
    // Список задач был изменен
    if (
      currentValue.length === prevValue.length &&
      currentValue.every((value) => prevValue.some((_value) => value === _value))
    )
      return;

    if (currentValue.length) await updateTaskAdapter.subscribeTaskList(currentValue);
  },
  { deep: true },
);

// #endregion watch

// #region Функции
/**Сортировка проектов по названию */
const sortProjectsByName = (array: ProjectModel[]): ProjectModel[] => {
  return array?.slice().sort((a, b) => {
    const nameA = a.Name.toLowerCase();
    const nameB = b.Name.toLowerCase();

    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });
};
/**При обновлении задачи */
const onUpdateTask = async (taskId: number) => {
  if (!executionQueueIds.value.includes(taskId)) return;
};
/**При добавлении или удалении сотрудника из исполнителей задачи */
const onAddRemovePerformerTask = async (data: AddOrRemoveTaskEventDataModel) => {
  if (!props.isOpened) return;
  // Проект есть в текущем списке
  const isExist = projects.value.some((project) => data.ProjectId === project.Id);
  if (!isExist) {
    projects.value = sortProjectsByName([
      ...projects.value,
      new ProjectModel({
        Id: data.ProjectId,
        Name: data.ProjectName,
        ImageUrl: data.ProjectImageUrl,
        PreviewColor: data.ProjectPreviewColor,
      }),
    ]);
  } else {
    const resp = await adapter.getCountTasksByProjectId(
      data.ProjectId,
      new TaskFilterModel({
        Performers: [props.user.Id],
      }),
    );
    // Запрос успешен и задачи в проекте отсутствуют
    if (resp.IsSuccess && resp.Value === 0) {
      projects.value = projects.value.filter((project) => project.Id !== data.ProjectId);
    }
  }
};

/**Добавить задачу в очередность */
const addExecutionTask = async (_task: OrderTaskModel, user: TeammateModel) => {
  emit('toggleExecutionTask', user?.Id);
  await addTaskZmkForUser(user?.Id || CurrentUser.Id, _task.Id);
};
/** Удалить задачу из очередности */
const removeExecutionTask = async (_taskId: number, user: TeammateModel) => {
  emit('toggleExecutionTask', user?.Id);
  await removeTaskZmkForUser(user?.Id || CurrentUser.Id, _taskId);
};

/**
 * Метод добавление в очередность
 * @param _userId ID юзера
 * @param _taskId ID задачи
 * @returns
 */
const addTaskZmkForUser = async (_userId: number, _taskId: number) => {
  const response = await adapter.addTaskZmkForUserAsync(
    new AddTaskZmkForUserRequest({
      UserId: _userId,
      TaskId: _taskId,
    }),
  );

  if (response.Value) {
    addNotification('Тикет добавлен в очередность');
    // emit("updateTaskOrder", _taskId, true);
  } else {
    addNotification(response.ErrorMessage, true, 5000);
  }
};
/**
 * Метод удаления из очередности
 * @param _userId ID юзера
 * @param _taskId ID задачи
 * @returns
 */
const removeTaskZmkForUser = async (_userId: number, _taskId: number) => {
  const response = await adapter.removeTaskZmkForUserAsync(
    new AddTaskZmkForUserRequest({
      UserId: _userId,
      TaskId: _taskId,
    }),
  );
  if (response.Value) {
    addNotification('Тикет удален из очередности');
    // emit("updateTaskOrder", _taskId, false);
  } else {
    addNotification(response.ErrorMessage, true, 5000);
  }
};
/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'team-tasks',
      life: life ?? 2000,
      closable: true,
    }),
  );
};
/**Изменить кол-во элементов на странице */
const changePageStep = async (count: number, userId: number) => {
  emit('changePageStep', count, userId);
};
/**Обновить текущую страницу */
const changeCurrentPage = async (
  currentPage: number,
  pageResponse: PageResponse,
  userId: number,
) => {
  emit('changeCurrentPage', currentPage, pageResponse, userId);
  props.pageResponse.Current = currentPage;
};

const sortingData = ref();
/**Обновить тип сортировки */
const updateSortData = async (data: TaskSortingModel) => {
  sortingData.value = new TaskSortingModel(data);
  emit('sortData', sortingData.value);
};
const startIndex = ref(0);
/**Получить id перетаскиваемой задачи*/
const getDragTaskId = (isDragging: boolean, model: DragModel<OrderTaskModel>) => {
  dragTaskId.value = model.Data.Id;
  startIndex.value = dragTasks.value.findIndex((task) => task.Data.Id === dragTaskId.value);
};
/**Получить положение перетаскиваемой задачи и отправить новый номер на сервер */
const getDragTaskPosition = async () => {
  const index = dragTasks.value.findIndex((task) => task.Data.Id === dragTaskId.value);
  if (startIndex.value > index) newPosition.value = dragTasks.value[index + 1]?.Data.Number;
  else newPosition.value = dragTasks.value[index - 1]?.Data.Number;
  //TODO
  await adapter.addTaskZmkForUserAsync(
    new AddTaskZmkForUserRequest({
      UserId: userId.value,
      TaskId: dragTaskId.value,
      Number: newPosition.value,
    }),
  );
};
/**Открыть шторку задачи */
const openTaskDrawer = (data) => {
  emit('openTaskDrawer', data);
};
// #endregion Функции

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TirPmNotificationGroup), {
      group: "teammate-card",
      position: "top-right",
      zIndex: 20000
    }),
    _createElementVNode("div", _hoisted_1, [
      (!__props.showOnlyMyTasks)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(TirPmIconView), {
              "is-rounded": "",
              "is-bordered": false,
              size: 24,
              "color-code": __props.user?.AvatarColor
            }, {
              mainSlot: _withCtx(() => [
                (__props.user?.ImageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: __props.user?.ImageUrl
                    }, null, 8, _hoisted_3))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      textContent: _toDisplayString(userInitials.value)
                    }, null, 8, _hoisted_4))
              ]),
              _: 1
            }, 8, ["color-code"]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(`${__props.user?.FirstName} ${__props.user?.LastName}`), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["teammate-card__main-header", { 'ml-1': __props.showOnlyMyTasks }])
        }, [
          _createVNode(_unref(TaskHeader), {
            "enable-sorting": "",
            columns: columns,
            "view-settings": __props.viewElements,
            "onUpdate:sortData": updateSortData
          }, null, 8, ["view-settings"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["teammate-card_content", { 'ml-1': __props.showOnlyMyTasks }])
        }, [
          _createVNode(_unref(TirPmDraggableSorting), {
            "is-allow-scroll": "",
            "disable-side-indent": "",
            "is-allow-click-delay": "",
            enabled: __props.isEnableDrag,
            class: _normalizeClass({ 'teammate-card_no-drag': !__props.isEnableDrag }),
            "data-class": "tasks-order-list__drag-task",
            data: dragTasks.value,
            indent: 8,
            onDragComponentOnDrag: getDragTaskId,
            onChange: getDragTaskPosition
          }, {
            item: _withCtx((props) => [
              _createVNode(TaskOrderLi, {
                isStatusLeftBlock: "",
                user: __props.user,
                task: props.item,
                columns: columns,
                "view-settings": __props.viewElements,
                "full-change-access-order": fullChangeAccessOrder.value,
                onRemove: _cache[0] || (_cache[0] = ($event: any) => (removeExecutionTask($event, __props.user))),
                onOpenTaskDrawer: openTaskDrawer
              }, null, 8, ["user", "task", "view-settings", "full-change-access-order"])
            ]),
            _: 1
          }, 8, ["enabled", "class", "data"]),
          (tasks.value?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tasks.value, (task) => {
                  return (_openBlock(), _createBlock(ProjectTaskLi, {
                    key: task.Id,
                    task: task,
                    user: __props.user,
                    hideIconName: "",
                    showStar: false,
                    isStatusLeftBlock: "",
                    atExecution: task.IsHighlighted,
                    columns: columns,
                    "view-settings": __props.viewElements,
                    tasksIds: __props.tasksIds,
                    onAdd: _cache[1] || (_cache[1] = ($event: any) => (addExecutionTask($event, __props.user))),
                    onOpenTaskDrawer: openTaskDrawer,
                    onRemoveTask: _cache[2] || (_cache[2] = ($event: any) => (emit('removeTask', $event)))
                  }, null, 8, ["task", "user", "atExecution", "view-settings", "tasksIds"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (tasks.value?.length == 0 && queuedTasks.value?.length == 0)
            ? (_openBlock(), _createBlock(_unref(TirPmSystemMessage), { key: 1 }, {
                mainTitleSlot: _withCtx(() => [
                  _createTextVNode("Задачи не найдены")
                ]),
                descriptionSlot: _withCtx(() => [
                  _createTextVNode("Обновите или сбросьте фильтр")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 2),
        (__props.pageResponse.Current && __props.pageResponse.Count > 15)
          ? (_openBlock(), _createBlock(_unref(TirPmPagination), {
              key: 0,
              class: "project-tasks__paginator",
              showMoreElements: "",
              "model-value": __props.pageResponse.Current,
              "range-size": 3,
              pages: pagesCount.value,
              options: [15, 25, 50, 100],
              "count-elements": __props.pageStep,
              "onUpdate:countElements": _cache[3] || (_cache[3] = ($event: any) => (changePageStep($event, __props.user?.Id || _unref(CurrentUser).Id))),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (changeCurrentPage($event, __props.pageResponse, __props.user?.Id || _unref(CurrentUser).Id)))
            }, null, 8, ["model-value", "pages", "count-elements"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})